import {
  AgentVerificationCheck,
  DetailsMatchingStep,
  ValidationSubmissionConfigurationResponse
} from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'

export const getDetailsMatchingStep = (
  config?: ValidationSubmissionConfigurationResponse | null
): DetailsMatchingStep | undefined => {
  const agentVerificationCheck = config?.configuration.checks.find(
    (check): check is AgentVerificationCheck => check.type === 'agent_verification'
  )

  return agentVerificationCheck?.associationChecks?.find(check => check.type === 'automatic_document_review')?.steps
    ?.detailsMatching
}

export const isDetailsMatchingDeterministic = (config?: ValidationSubmissionConfigurationResponse | null) =>
  getDetailsMatchingStep(config)?.mode === 'deterministic'
